<div class="modal modal-xl fade" id="addMembersToPropertyModal" msEscClose (escPressed)="onCancelRequested()"
    data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header border-0 p-4">
                <h5 class="modal-title">Add Members to Property</h5>
            </div>
            <div class="modal-body">
                <ms-member-list 
                  [activePropertyId]="propertyId()" 
                  [currentMemberListViewLocation]="memberListViewLocations.AddMemberToPropertyModal"
                  (addMemberRequested)="onAddMembersRequested($event)"
                ></ms-member-list>
            </div>
            <div class="modal-footer border-0 p-4">
                <button type="button" class="btn btn-ms-secondary" data-bs-dismiss="modal" (click)="onCancelRequested()">Cancel</button>
            </div>
        </div>
    </div>
</div>

<ms-info-modal 
  #addMembersToPropertyInfoModalRef
  modalId="addMembersToPropertyInfoModal" 
  (onConfirm)="onConfirmInfoModal()"
/>

<ms-confirmation-modal 
  #addMembersToPropertyConfirmationModalRef
  modalId="addMembersToPropertyConfirmationModal"
  confirmButtonText="Add"
  cancelButtonText="Cancel"
  [isSubmitting]="isSubmitting"
  (confirmed)="addMembersToProperty()"
  (cancelled)="abortAddMembersToPropertyConfirmation()"
/>
